module.exports = __webpack_public_path__ + "static/media/cfpayments.2c32b875.png";